module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_thylakoid_and_stroma_photosynthesis_5-b50e086b7b194bb87ab1341bd6292a50.jpg";